/**
 * Aus den Ablage-Adressen, die n8n in `ergebnis` schreibt, die Adresse fuer einen DIREKTEN
 * Download machen (Auftrag 2026-10-13: "kein Link zum Drive-Ordner oder Google Docs, sondern
 * die Dokumente direkt herunterladen").
 *
 * - Google Doc (`docs.google.com/document/d/<id>/edit`) -> `/export?format=docx`: Google
 *   liefert das Dokument als Word-Datei, benannt nach dem Dokumenttitel.
 * - Drive-Datei (`drive.google.com/file/d/<id>/view`, `open?id=`, `uc?id=`) ->
 *   `drive.google.com/uc?export=download&id=<id>`: die Datei selbst statt der Vorschauseite.
 *
 * Beide Muster sind seit Jahren in Gebrauch (Google-Hilfe-Community, Stack Overflow), aber keine
 * zugesicherte API. Gemessen werden konnte am 2026-10-13 nicht: Die Bau-Umgebung sperrt
 * Google-Hosts. Erster Live-Test entscheidet. Die Anmeldung bei Google und die Freigabe der Datei
 * gelten wie bisher beim Oeffnen.
 *
 * Die Kennung wird gegen den Zeichensatz von Drive-Kennungen geprueft: Die Adresse kommt aus
 * Firestore, also aus einer fremden Quelle, und landet als `href` in der Seite.
 */
const KENNUNG = /^[A-Za-z0-9_-]{10,}$/;

function kennungAus(url: URL, pfadMuster: RegExp): string | null {
  const ausPfad = pfadMuster.exec(url.pathname)?.[1];
  const kennung = ausPfad ?? url.searchParams.get('id');
  return kennung && KENNUNG.test(kennung) ? kennung : null;
}

function alsUrl(roh: string): URL | null {
  try {
    const url = new URL(roh);
    return url.protocol === 'https:' ? url : null;
  } catch {
    return null;
  }
}

/** Word-Download eines Google Docs, sonst `null`. */
export function wordDownload(roh: string): string | null {
  const url = alsUrl(roh);
  if (!url || url.hostname !== 'docs.google.com') return null;
  const kennung = kennungAus(url, /^\/document\/d\/([^/]+)/);
  return kennung ? `https://docs.google.com/document/d/${kennung}/export?format=docx` : null;
}

/** Direkter Download einer Drive-Datei (etwa eines Bildes), sonst `null`. */
export function driveDownload(roh: string): string | null {
  const url = alsUrl(roh);
  if (!url || url.hostname !== 'drive.google.com') return null;
  // Ein Ordner hat keinen Einzeldownload.
  if (url.pathname.startsWith('/drive/folders/')) return null;
  const kennung = kennungAus(url, /^\/file\/d\/([^/]+)/);
  return kennung ? `https://drive.google.com/uc?export=download&id=${kennung}` : null;
}
